/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconPaymentPlan/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconPaymentPlan({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconPaymentPlan",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#653CAD"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconPaymentPlan.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z12YWP4': alignSelf,'--mt-2-Z12YWP4': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z12YWP4': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z12YWP4': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z12YWP4': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z12YWP4': opacity,'--w-10-Z12YWP4': typeof width === 'number' ? `${width}px` : width,'--h-11-Z12YWP4': typeof height === 'number' ? `${height}px` : height,'--f-12-Z12YWP4': fill,'--a-7-Z12YWP4': isAnimated ? animation : "none",'--sd-8-Z12YWP4': isAnimated ? strokeDashoffset : 0,'--sd-9-Z12YWP4': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconPaymentPlan.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M15.826 3a5.174 5.174 0 100 10.347 5.174 5.174 0 000-10.347zm-2.14 3.974c0-.919.745-1.663 1.663-1.663h.838a1.776 1.776 0 011.678 1.186.695.695 0 11-1.311.464.388.388 0 00-.366-.26h-.84a.272.272 0 00-.057.538l1.277.28a1.78 1.78 0 01-.38 3.517h-.723a1.78 1.78 0 01-1.678-1.186.695.695 0 111.312-.463.389.389 0 00.366.259h.723a.389.389 0 00.083-.769l-1.278-.279a1.663 1.663 0 01-1.307-1.624zm-8.302 4.649H3v5.174l2.365 2.365a5.174 5.174 0 003.658 1.515h7.558a1.94 1.94 0 100-3.88h-3.592a2.73 2.73 0 01-4.547 1.154l-1.875-1.876a.808.808 0 011.144-1.144l1.875 1.876a1.112 1.112 0 001.691-1.434l-2.235-2.235a5.174 5.174 0 00-3.658-1.515z"
 style={{'--f-12-Z12YWP4': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}